/** Production portal destinations for public website CTAs */
const PORTAL_ORIGIN =
  (import.meta.env.VITE_PORTAL_ORIGIN as string | undefined)?.replace(/\/$/, '') ||
  'https://portal.perfectpredict.com'

export const portalLinks = {
  home: `${PORTAL_ORIGIN}/app`,
  login: `${PORTAL_ORIGIN}/app/login`,
  register: `${PORTAL_ORIGIN}/app/register`,
  support: `${PORTAL_ORIGIN}/app/support`,
} as const
